import { render, staticRenderFns } from "./currency.vue?vue&type=template&id=aec3cbd6&scoped=true"
import script from "./currency.vue?vue&type=script&lang=js"
export * from "./currency.vue?vue&type=script&lang=js"
import style0 from "./currency.vue?vue&type=style&index=0&id=aec3cbd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec3cbd6",
  null
  
)

export default component.exports